module.exports = __webpack_public_path__ + "static/media/head-vr.cc5e7938.svg";